module.exports = __webpack_public_path__ + "static/media/gots.1578fd39.png";